import React from "react";
import { Accordion, Card, Container, Row, Col } from "react-bootstrap";

function Copyright() {


  return (
    <section>
      <Container fluid className="home-section" id="#">
        <Container className="home-content">

          <Row style={{ paddingTop: "50px", paddingBottom: "10px" }}>
            <h1 className="home-heading">
              <strong className="white">DCRC.RACING</strong>
            </h1>
          </Row>
          <Row style={{ paddingTop: "5px", paddingBottom: "10px" }}>
            <h1 className="home-heading">
              <strong className="white">TERMS &amp; CONDITIONS</strong>
            </h1>
          </Row>
          <Row>
          <Col md={12}>
          <br/>
          <span className="home-about-body">DCRC.RACING has released a series of Non-Fungible Tokens based on the Avalanche blockchain. 
          This website serves as the medium in which buyers can buy the NFT during the minting/sale of this series. Prospective buyers are responsible for 
          validating all transactions taking place in regard to the sale, minting and resales before approving any transactions through their wallets and 
          also managing their Avalanche Wallets. Buyers should take into consideration that since the Smart Contract is on the Avalanche network any transactions 
          cannot be reversed or restored after taking place.</span>

          <span className="home-about-body">
          This website does not carry a warranty and to any of its connected services. Use of this website is the sole responsibility of the user and all 
          transactions involving DCRC.RACING.</span>
          <br/>
          <br/>
          <br/>
            <h3 className="home-heading">
              <strong className="white">- NFT Owner</strong>
            </h3>
          <span className="home-about-body">The DCRC NFT lives on the Avalanche Blockchain. The buyer is the sole owner of the Token ID and under no circumstances can anyone modify, seize or take ownership of the NFT without approval of the Owner through the Avalanche Network and the Smart Contract. &nbsp;</span>

          <br/>
          <br/>
          <br/>
            <h3 className="home-heading">
              <strong className="white">- NFT Use</strong>
            </h3>
          <span className="home-about-body">Where the Owner of the NFT complies with the Terms and Conditions set by the DCRC he/she may use and/or display 
          the Art Collectible through the following:</span>
          <br/>
          <span className="home-about-body">&nbsp;&nbsp;&nbsp;&nbsp;a)Personal and non-commercial use</span>
          <br/>
          <span className="home-about-body">&nbsp;&nbsp;&nbsp;&nbsp;b)Posting through a NFT Marketplace in order to sell the DCRC NFT, in the condition that the Marketplace verifies the true identity of the NFT</span>
          <br/>
          <span className="home-about-body">&nbsp;&nbsp;&nbsp;&nbsp;c)Any 3rd party that allows the participation of your NFT as long as the NFT is verified and verifies ownership of the NFT &nbsp;</span>


          <br/>
          <br/>
          <br/>
            <h3 className="home-heading">
              <strong className="white">- Commercial Purpose</strong>
            </h3>
          <span className="home-about-body">Where the Owner of the NFT complies with the Terms and Conditions set by the DCRC he/she may use and display the purchased NFT for 
          creating other versions based on their own NFT, displaying through marketplaces, Virtual Galleries, Galleries, selling Merchandise. All the prior licenses are applicable 
          only for the version or specific NFT and should not display and/or use any DCRC NFT owned by any other Owner of the same series.
          Any use of the NFT should take place after the NFT Collection and ownership of the NFT are verified.
          General Copyrights and IP of the series of the DCRC NFT are owned by the Development team that created the series and any rights for commercial use of any NFT from the 
          DCRC Collection are applicable only to the specific NFT Owned by the buyer.
          Development of the Collection of the DCRC NFT and Intellectual Property (IP) is owned only by the original Development team. IP refers only to the development of the 
          series, individual NFT from the DCRC Collection IP is owned by the owner of the NFT.&nbsp;</span><br/>
          
          <br/>
          </Col>
          </Row>
          <Row style={{ justifyContent: "center", paddingTop: "100px", paddingBottom: "10px" }}></Row>
          <Row style={{ justifyContent: "center", paddingTop: "100px", paddingBottom: "10px" }}></Row>
        </Container>
      </Container>
    </section>
  );
}

export default Copyright;
